import { useGetGlobalUsageStatsQuery } from "@/redux/api/analytics.rtkq";
import StatsCards from "@/components/super-admin/overview/StatsCards";
import UsageChart from "@/components/super-admin/overview/UsageChart";
import TopPerformers from "@/components/super-admin/overview/TopPerformers";
import { Loader2 } from "lucide-react";

const OverviewTab = () => {
  const { data: stats, isLoading, error } = useGetGlobalUsageStatsQuery({ days: 30 });

  if (isLoading) {
    return (
      <div className="flex h-[400px] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-[200px] items-center justify-center text-red-500">
        שגיאה בטעינת הנתונים: {JSON.stringify(error)}
      </div>
    );
  }

  if (!stats) {
    return <div className="text-center py-8">אין נתונים זמינים</div>;
  }

  return (
    <div className="space-y-6">
      <StatsCards
        totalCredits={stats.totalCredits ?? 0}
        totalOps={stats.totalOps ?? 0}
        activeAccountsCount={stats.topAccounts?.length ?? 0}
      />
      <UsageChart data={stats.dailyStats ?? []} />
      <TopPerformers topApps={stats.topApps ?? []} topAccounts={stats.topAccounts ?? []} />
    </div>
  );
};

export default OverviewTab;
